import InstallAppPrompt from '../../components/InstallAppPrompt';

function InstallAppSettings() {
  return (
    <div className="settings-panel">
      <h2>Install GLPT</h2>
      <p>Add GLPT to your home screen so it opens like an app.</p>

      <InstallAppPrompt />

      <div className="install-help-text">
        <h3>Manual install instructions</h3>

        <p>
          <strong>iPhone/iPad:</strong> Open GLPT in Safari, tap the Share button, then choose Add
          to Home Screen.
        </p>

        <p>
          <strong>Android:</strong> Open GLPT in Chrome, then tap Install App or Add to Home Screen.
        </p>
      </div>
    </div>
  );
}

export default InstallAppSettings;
